const defaultConfig = {
  timeout: 5000,
  showProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  position: 'rightTop'
}

export default defaultConfig
